import * as React from 'react';
import * as Styled from './WidgetError.styles';
/**
 * Styled error message for a widget
 */
export const WidgetError = ({ message = 'There was an error loading this information', }) => {
    return (React.createElement(Styled.Wrapper, null,
        React.createElement(Styled.ErrorImage, null),
        message));
};
WidgetError.defaultProps = {};
export default WidgetError;
